/**
 * Identificador global inyectado en build por Angular `--define`
 * (ver apps/web/Dockerfile.kamal y apps/web/Dockerfile.prod).
 * En desarrollo local no existe: `typeof` evita el ReferenceError.
 */
declare const SENTRY_RELEASE_SHA: string | undefined;

/**
 * Devuelve el SHA de git con el que se buildeó el bundle, o `undefined`
 * si no fue inyectado (dev local). Nunca inventa un valor.
 */
export function resolveSentryRelease(): string | undefined {
  if (typeof SENTRY_RELEASE_SHA !== 'string') {
    return undefined;
  }

  const release = SENTRY_RELEASE_SHA.trim();

  return release.length > 0 ? release : undefined;
}
